import { OrderStatus } from '@wix/ambassador-ecom-v1-order/types';

export enum ORDERS_FULFILLMENT_STATUS {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Ready = 'Ready',
  InDelivery = 'In_Delivery',
  Fulfilled = 'Fulfilled',
  Cancelled = 'Cancelled',
}

export const UNKNOWN_STATUS = 'Unknown';

export const getOrderStatus = (
  restaurantStatus: string | undefined,
  ecomStatus: string | undefined,
) => {
  if (ecomStatus === OrderStatus.CANCELED) {
    return OrderStatus.CANCELED;
  }

  if (
    Object.values(ORDERS_FULFILLMENT_STATUS).includes(
      restaurantStatus as ORDERS_FULFILLMENT_STATUS,
    )
  ) {
    return restaurantStatus;
  }

  return UNKNOWN_STATUS;
};
